import { render, staticRenderFns } from "./AttendanceTeacherEdit.vue?vue&type=template&id=1ebd95ba"
import script from "../../controllers/attendance_teacher/attendance-teacher-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/attendance_teacher/attendance-teacher-edit.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceTeacherEdit.vue?vue&type=style&index=0&id=1ebd95ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports